import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import './assets/styles/main.scss';
import HomePage from './pages/HomePage';
import HakkimizdaPage from './pages/HakkimizdaPage';
import VizyonMisyonPage from './pages/VizyonMisyonPage';
import IsBasvurusuPage from './pages/IsBasvurusuPage';
import HastaneRefakatciPage from './pages/HastaneRefakatciPage';
import TibbiBirimlerPage from './pages/TibbiBirimlerPage';
import HekimlerPage from './pages/HekimlerPage';
import KaliteYonetimiPage from './pages/KaliteYonetimiPage';
import AnlasmaliSigortalarPage from './pages/AnlasmaliSigortalarPage';
import IletisimPage from './pages/IletisimPage';
import OrganizasyonSemasiPage from './pages/OrganizasyonSemasiPage';
import DoctorProfilePage from './pages/DoctorProfilePage';
import KvkkPage from './pages/KvkkPage';
import TupBebek from "./pages/TupBebekPage";
import IVFArticle from './components/layout/IVFSlider'; // /tup-bebek/:slug
import HastaMemnuniyetAnketleriPage from './pages/HastaMemnuniyetAnketleriPage';
import AyaktanHastaAnketPage from './pages/AyaktanHastaAnketPage';
import YatanHastaAnketPage from './pages/YatanHastaAnketPage';
import AcilServisAnketPage from './pages/AcilServisAnketPage';
import HastaneCalisanlariGorusOneriPage from './pages/HastaneCalisanlariGorusOneriPage';
import IstenmeyenOlayPage from './pages/IstenmeyenOlayPage';
import SosyalHizmetBirimiPage from './pages/SosyalHizmetBirimiPage';
import DuzenleyiciOnleyiciFaaliyetPage from './pages/DuzenleyiciOnleyiciFaaliyetPage';
import HastaHaklariBildirgesiPage from './pages/HastaHaklariBildirgesiPage';
import BashekimMesajiPage from './pages/BashekimMesajiPage';

import AdminLayout from './admin/AdminLayout';
import LoginPage from './admin/LoginPage';
import Dashboard from './admin/Dashboard';
import AdminGuard from './admin/AdminGuard';

import AnlasmaliCategoriesYonetim from './admin/anlasmaliCategoriesYonetim';
import AnlasmaliPartnersYonetim from './admin/anlasmaliPartnersYonetim';
import DoctorProfilesYonetim from './admin/doctorProfilesYonetim';
import CompanionVisitorYonetim from './admin/companionVisitorYonetim';
import ContactYonetim from './admin/contactYonetim';
import DoctorsYonetim from './admin/doctorsYonetim';
import DoctorsGridYonetim from './admin/doctorsGridYonetim';

import DoctorsIntroYonetim from './admin/doctorsIntroYonetim';
import FeatureHakkimizdaYonetim from './admin/featureHakkimizdaYonetim';
import FeatureStripYonetim from './admin/featureStripYonetim';
import FeedbackMessagesYonetim from './admin/feedbackMessagesYonetim';
import FeedbackSectionYonetim from './admin/feedbackSectionYonetim';
import MedicalUnitsYonetim from './admin/medicalUnitsYonetim';
import PageAboutIntroYonetim from './admin/pageAboutIntroYonetim';
import PageDoctorsHeroYonetim from './admin/pageDoctorsHeroYonetim';
import PageHeroYonetim from './admin/pageHeroYonetim';
import VisionMissionYonetim from './admin/visionMissionYonetim';
import VisitItemsYonetim from './admin/visitItemsYonetim';
import MediaYonetim from './admin/mediaYonetim';
import TibbiBirimlerYonetim from './admin/tibbiBirimlerYonetim';
import CareersYonetim from './admin/careersYonetim';
import AyaktanHastaAnketYonetim from './admin/ayaktanHastaAnketYonetim';
import YatanHastaAnketYonetim from './admin/yatanHastaAnketYonetim';
import AcilServisAnketYonetim from './admin/acilServisAnketYonetim';
import HastaneCalisanlariGorusOneriYonetim from './admin/hastaneCalisanlariGorusOneriYonetim';
import IstenmeyenOlayYonetim from './admin/istenmeyenOlayYonetim';
import SosyalHizmetBirimiYonetim from './admin/sosyalHizmetBirimiYonetim';
import DuzenleyiciOnleyiciFaaliyetYonetim from './admin/duzenleyiciOnleyiciFaaliyetYonetim';
import WelcomeModalYonetim from './admin/welcomeModalYonetim';
import SliderYonetim from './admin/sliderYonetim';
import BashekimMesajiYonetim from './admin/bashekimMesajiYonetim';
import { ivfItems } from './data/ivfItems';
import WelcomeModal from './components/common/WelcomeModal';
import CookieConsent from './components/common/CookieConsent';
import { toUrl } from './lib/config';

// Geçici 404 sayfası
const NotFound = () => (
  <div className="container py-5 text-center">
    <h1>404</h1>
    <p>Sayfa bulunamadı.</p>
  </div>
);

function App() {
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: 'Megapark Hastanesi',
    description: 'Sağlığınız için yanınızdayız',
    imageUrl: ''
  });

  useEffect(() => {
    // Sayfa yüklenince modal'ı göster ve backend'den veri çek
    const hasSeenModal = sessionStorage.getItem('hasSeenWelcomeModal');
    if (!hasSeenModal) {
      fetchActiveModal();
    }
  }, []);

  const fetchActiveModal = async () => {
    try {
      const url = toUrl('/api/welcome-modal/active');
      const response = await fetch(url);
      
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data) {
          setModalData({
            title: result.data.title,
            description: result.data.description,
            imageUrl: result.data.imageUrl
          });
        }
        setShowWelcomeModal(true);
      }
    } catch (err) {
      console.error('Modal yükleme hatası:', err);
      // Hata olsa bile varsayılan modal'ı göster
      setShowWelcomeModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowWelcomeModal(false);
    sessionStorage.setItem('hasSeenWelcomeModal', 'true');
  };

  return (
    <Router>
      <WelcomeModal 
        show={showWelcomeModal} 
        onHide={handleCloseModal}
        title={modalData.title}
        description={modalData.description}
        image={modalData.imageUrl}
      />
      <CookieConsent />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hakkimizda" element={<HakkimizdaPage />} />
          <Route path="/vizyon-misyon" element={<VizyonMisyonPage />} />
          <Route path="/is-basvurusu" element={<IsBasvurusuPage />} />
          <Route path="/hastane-refakatci" element={<HastaneRefakatciPage />} />
          <Route path="/tibbi-birimler" element={<TibbiBirimlerPage />} />
          <Route path="/hekimler" element={<HekimlerPage />} />
          <Route path="/kalite-yonetimi" element={<KaliteYonetimiPage />} />
          <Route path="/anlasmali-sigortalar" element={<AnlasmaliSigortalarPage />} />
          <Route path="/organizasyon-semasi" element={<OrganizasyonSemasiPage />} />
          <Route path="/hekim/:slug" element={<DoctorProfilePage />} />
          <Route path="/iletisim" element={<IletisimPage />} />
          <Route path="/kvkk" element={<KvkkPage />} />
          <Route path="tup-bebek" element={<TupBebek/>} />
          <Route path="/tup-bebek/:slug" element={<IVFArticle items={ivfItems} />} />
          <Route path="/hasta-memnuniyet-anketleri" element={<HastaMemnuniyetAnketleriPage />} />
          <Route path="/anket/ayaktan-hasta" element={<AyaktanHastaAnketPage />} />
          <Route path="/anket/yatan-hasta" element={<YatanHastaAnketPage />} />
          <Route path="/anket/acil-servis" element={<AcilServisAnketPage />} />
          <Route path="/hastane-calisanlari-gorus-ve-oneri-formu" element={<HastaneCalisanlariGorusOneriPage />} />
          <Route path="/istenmeyen-olay" element={<IstenmeyenOlayPage />} />
          <Route path="/sosyal-hizmet-birimi-hasta-gorusme-formu" element={<SosyalHizmetBirimiPage />} />
          <Route path="/duzenleyici-onleyici-faaliyet-talep-formu" element={<DuzenleyiciOnleyiciFaaliyetPage />} />
          <Route path="/hasta-haklari-bildirgesi" element={<HastaHaklariBildirgesiPage />} />
          <Route path="/bashekim-mesaji" element={<BashekimMesajiPage />} />

          {/* Admin */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
            <Route index element={<Dashboard />} />
            <Route path="anlasmali-categories" element={<AnlasmaliCategoriesYonetim />} />
            <Route path="anlasmali-partners" element={<AnlasmaliPartnersYonetim />} />
            <Route path="doctor-profiles" element={<DoctorProfilesYonetim />} />
            <Route path="contact" element={<ContactYonetim />} />
            <Route path="doctors" element={<DoctorsYonetim />} />
            <Route path="doctors-grid" element={<DoctorsGridYonetim />} />
            <Route path="companion-visitor" element={<CompanionVisitorYonetim />} />
            <Route path="doctors-intro" element={<DoctorsIntroYonetim />} />
            <Route path="feature-hakkimizda" element={<FeatureHakkimizdaYonetim />} />
            <Route path="feature-strip" element={<FeatureStripYonetim />} />
            <Route path="feedback-messages" element={<FeedbackMessagesYonetim />} />
            <Route path="feedback-section" element={<FeedbackSectionYonetim />} />
            <Route path="medical-units" element={<MedicalUnitsYonetim />} />
            <Route path="tibbi-birimler" element={<TibbiBirimlerYonetim />} />
            <Route path="page-about-intro" element={<PageAboutIntroYonetim />} />
            <Route path="page-doctors-hero" element={<PageDoctorsHeroYonetim />} />
            <Route path="page-hero" element={<PageHeroYonetim />} />
            <Route path="vision-mission" element={<VisionMissionYonetim />} />
            <Route path="visit-items" element={<VisitItemsYonetim />} />
            <Route path="media" element={<MediaYonetim />} />
            <Route path="careers" element={<CareersYonetim />} />
            <Route path="ayaktan-hasta-anket" element={<AyaktanHastaAnketYonetim />} />
            <Route path="yatan-hasta-anket" element={<YatanHastaAnketYonetim />} />
            <Route path="acil-servis-anket" element={<AcilServisAnketYonetim />} />
            <Route path="hastane-calisanlari-gorus-oneri" element={<HastaneCalisanlariGorusOneriYonetim />} />
            <Route path="istenmeyen-olay" element={<IstenmeyenOlayYonetim />} />
            <Route path="sosyal-hizmet-birimi" element={<SosyalHizmetBirimiYonetim />} />
            <Route path="duzenleyici-onleyici-faaliyet" element={<DuzenleyiciOnleyiciFaaliyetYonetim />} />
            <Route path="welcome-modal" element={<WelcomeModalYonetim />} />
            <Route path="slider" element={<SliderYonetim />} />
            <Route path="bashekim-mesaji" element={<BashekimMesajiYonetim />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
